/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import Group, { Item } from "./GroupCheck";

const GroupCheck = {
	Wrapper: Group,
	Item,
};

export default GroupCheck;
